    <p-dialog
    header="Assign Tags"
    [modal]="true" [(visible)]="showDialog"  (onHide)="cancelTagDialog()"
    [style]="{width: '45vw'}" appendTo="body">
    <div class='card tagTable'>
        <p-table [value]="$any(filteredTags)" selectionMode="multiple" [(selection)]="selectedTags" dataKey="id"
                 [paginatorDropdownAppendTo]="'body'"
                 #tagTable [paginator]="true" [rows]="tableConfig.pageSize" [showCurrentPageReport]="true" responsiveLayout="scroll"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [(first)]='tableConfig.first'
                 [rowsPerPageOptions]="[5,10,15]" [globalFilterFields]="['name']" [scrollable]="true">

            <ng-template pTemplate='caption'>
                <div class='p-grid'>
                    <div class='p-col-8'>
                        <input (input)="tagTable.filterGlobal($event.target.value, 'contains')" class='w-100'
                               type='text' pInputText placeholder='Search Tag...' />
                    </div>
                    <div class='p-col-4'>
                        <p-dropdown
                            [options]='filterOptions'
                            (onChange)='selectedTagType($event)' placeholder='Filter Dropdown'
                            [(ngModel)]="selectedFilterOption"
                            optionLabel='name'
                            appendTo='body'>
                        </p-dropdown>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate='header'>
                <tr>
                    <th style='width:100%'>
                        <div class='tagHeader'>
                            <div>Name</div>
                            <div (click)='emitAddNewTag()' style='cursor: pointer;'><i class='pi pi-plus'></i>
                            </div>
                        </div>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate='body' let-data let-index='rowIndex'>
                <tr [pSelectableRow]='data' [pSelectableRowIndex]='index'>
                    <td class='p-col-6'>
                        <p-tag [value]='data?.name' styleClass='p-ml-2'
                               [style]="{'background-color': data?.color}"></p-tag>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate='paginatorleft'>
                <p-button type='button' icon='pi pi-plus' styleClass='p-button-text'></p-button>
            </ng-template>
            <ng-template pTemplate='paginatorright'>
                <p-button type='button' icon='pi pi-cloud' styleClass='p-button-text'></p-button>
            </ng-template>
        </p-table>
    </div>

    <ng-template pTemplate='footer'>
        <button pButton label='Cancel' (click)='cancelTagDialog()' class='p-button-secondary'></button>
        <button pButton (click)='assignSelectedTag();' label='Assign'></button>
    </ng-template>
</p-dialog>
